// 做题类型，作答模式
export const readingPracticeTypeEnum = {
  // 朗读
  READ: 1,
  // 跟读（旧课文枚举， 废弃）
  // REPEAT_AFTER: 2,
  // 九宫格（目前没有使用）
  SUDOKU: 3,
  // 听写（目前没有使用）
  DICTATION: 4,
  // 复述（旧课文枚举，废弃）
  // REPEAT: 5,
  // 回答问题
  QUESTION_ANSWER: 6,
  // 角色对话/多人跟读
  ROLE_DIALOGUE: 10,
  // 逐句背诵/多人背诵
  MULTI_REPEAT: 11,
  // 句子领读
  SENTENCE_LEAD_READING: 12,
  // 句子朗读
  SENTENCE_READING: 13,
  // 对话类型专用逐句跟读
  DIALOGUE_FOLLOW: 14,
  // 通篇领读
  LEAD_READING: 15
}

// 需要使用课文分句并且info结构是数组的作答模式
export const answerModeGroupBySentence = [
  readingPracticeTypeEnum.ROLE_DIALOGUE,
  readingPracticeTypeEnum.MULTI_REPEAT,
  readingPracticeTypeEnum.DIALOGUE_FOLLOW
]

// 新课文素材类型（newReadingData.materialType 字段）
export const ReadingMaterialTypeEnum = {
  Poetry: 5, // 诗词
  Dialogue: 6, // 对话
  Article: 7 // 篇章
}

export const ReadingMaterialTypeMap = {
  [ReadingMaterialTypeEnum.Poetry]: { label: '诗词' },
  [ReadingMaterialTypeEnum.Dialogue]: { label: '对话' },
  [ReadingMaterialTypeEnum.Article]: { label: '篇章' }
}
